import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CoreUiModule } from '@pos-app/core-ui';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';

import { AllocateFitterComponent } from './containers/allocate-fitter/allocate-fitter.component';
import { OrdersForFitterComponent } from './components/orders-for-fitter/orders-for-fitter.component';
import { FitterFiltersComponent } from './components/fitter-filters/fitter-filters.component';
import { ArrayOfLineCardComponent } from './components/array-of-line-card/array-of-line-card.component';
import { OrdersForBookingComponent } from './components/orders-for-booking/orders-for-booking.component';
import { AllocateOrderDialogComponent } from './components/allocate-order-dialog/allocate-order-dialog.component';
import { FiltersReviewByWeekComponent } from './components/filters-review-by-week/filters-review-by-week.component';
import { FittersComponent } from './components/fitters/fitters.component';
import { OrderForBookingCardComponent } from './components/order-for-booking-card/order-for-booking-card.component';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, CoreUiModule, MatDialogModule, DragDropModule, MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule],
  declarations: [
    AllocateFitterComponent,
    OrdersForFitterComponent,
    FitterFiltersComponent,
    ArrayOfLineCardComponent,
    OrdersForBookingComponent,
    AllocateOrderDialogComponent,
    FiltersReviewByWeekComponent,
    FittersComponent,
    OrderForBookingCardComponent,
  ],
  exports: [AllocateFitterComponent],
})
export class FilterModule {}
